import { Box, Button, Typography } from "@/common/styles/style";
import { styles } from "./style";
import DataInput from "@/atoms/dataInput";
import { FormEvent, useState } from "react";
import BackButton from "@/atoms/backButton";
import { useNavigate } from "react-router-dom";
import { Routes } from "@/router/routes";
import ErrorMessage from "@/atoms/errorMessage";

export default function PasswordSend() {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSendEmail = async (e: FormEvent) => {
    e.preventDefault();

    if (!email) {
      setError("メールアドレスを入力してください。");
      return;
    }

    try {
      const response = await fetch("/api/password/reset", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email }),
      });

      const data = await response.json();
      if (response.ok) {
        console.log(data.message);
        alert(`${email}に送信を完了しました。`);
        setError(null);
        setIsSubmitted(true);
      } else {
        setError(data.message);
      }
    } catch (error) {
      console.error("API呼び出しエラー:", error);
      setError("エラーが発生しました。もう一度試してください。");
    }
  };

  const handleReturnLogin = () => {
    navigate(Routes.LOGIN);
  };

  return (
    <Box sx={styles.container}>
      {!isSubmitted ? (
        <Box sx={styles.box}>
          <ErrorMessage error={error} />
          <BackButton style={styles.backButton} />
          <Typography variant="h5" align="center" marginBottom={5}>
            パスワードリセットメール送信
          </Typography>
          <Typography align="center" marginBottom={5}>
            パスワード再設定用URLをメールで送信します。
          </Typography>
          <form onSubmit={handleSendEmail}>
            <DataInput
              datatype="TextField"
              label="メールアドレス"
              textProps={{
                variant: "outlined",
                sx: styles.input,
                value: email,
              }}
              onChange={(e) => setEmail(e)}
              formControlProps={{
                sx: styles.form,
              }}
            />
            <Button variant="contained" sx={styles.button} type="submit">
              送信
            </Button>
          </form>
        </Box>
      ) : (
        <Box sx={styles.isSubmittedBox}>
          <Typography variant="h5" align="center" marginBottom={5}>
            パスワードリセットメール送信完了
          </Typography>
          <Typography align="center" marginBottom={5}>
            パスワード再設定用URLをメールで送信しました。
          </Typography>
          <Button
            variant="text"
            sx={styles.moveButton}
            onClick={handleReturnLogin}
          >
            ログイン画面へ戻る
          </Button>
        </Box>
      )}
    </Box>
  );
}
